module.exports = __webpack_public_path__ + "static/img/af-solution-banner.378c8c3b.png";